import { Component, inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-message',
  imports: [MatIcon],
  template: `
    <div class="flex justify-between items-center gap-x-20">
      <span>{{ data?.message }}</span>
      <mat-icon class="overflow-initial">{{ data?.icon }}</mat-icon>
    </div>
  `
})
export class MessageComponent {
  data = inject(MAT_SNACK_BAR_DATA);
}
